// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"ljydh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _index = require("../../app/configuration/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
$(document).ready(function() {
    // mobile menu classes
    $("#open_menu").click(showMenu);
    function showMenu() {
        $(".header_form").addClass("show");
        $(".nav_open").addClass("hide_1");
        $(".close").addClass("show");
        $(".one, .two, .three").addClass("animate");
    }
    $(".close").click(hideMenu);
    function hideMenu() {
        $(".header_form").removeClass("show");
        $(".close").removeClass("show");
        $(".nav_open").removeClass("hide_1");
        $(".gridContainer").removeClass("blur");
        $(".one, .two, .three").removeClass("animate");
    } // Get the hash, minus the "#", strip the leading & trailing slashes & split it by slash
    var hash = window.location.hash.substring(1).replace(/^\/|\/$/g, "").split("/");
    if (hash && hash[0] == "reset-password") {
        var token = hash[1], expiredMessage = "This reset password link has expired. Please try again using a different link.", form = $("#reset-password .reset-password"), errorBox = $("#reset-password .errors"), infoBox = $("#reset-password .return-info"), submit = form.children(".submit");
        $.get((0, _indexDefault.default).API_ROOT + "/password/reset", {
            token: token
        }).fail(function(response) {
            errorBox.hide().text(expiredMessage).slideDown();
            form.hide();
        });
        $.fancybox("#reset-password", {
            padding: 0
        });
        function enableSubmit() {
            submit.val("Reset").animate({
                opacity: 1
            }).prop("disabled", false);
        }
        function disableSubmit() {
            submit.val("Resetting...").animate({
                opacity: 0.5
            }).prop("disabled", true);
        }
        form.submit(function(e) {
            e.preventDefault();
            $("#token").val(token);
            var data = $(this).serialize();
            disableSubmit();
            $.ajax({
                type: "POST",
                url: (0, _indexDefault.default).API_ROOT + "/password/reset",
                xhrFields: {
                    withCredentials: true
                },
                data: data
            }).done(function(response) {
                disableSubmit();
                errorBox.text("");
                form.hide(400);
                infoBox.text("Your password has been successfully reset. You can now login using your new password");
            }).fail(function(response) {
                enableSubmit();
                if (response.status === 404) {
                    var responseJson = JSON.parse(response.responseText);
                    errorBox.text(responseJson && responseJson.status && responseJson.status.message || expiredMessage);
                } else {
                    var errors = JSON.parse(response.responseText).meta.errors, errorText = "";
                    for(var error in errors)errorText += "\n" + errors[error];
                    errorBox.text(errorText);
                }
            });
        });
    } else if (hash && hash[0] == "expired-link") $.fancybox("#expired-link", {
        padding: 0
    });
    var refreshSession = function() {
        $.ajax({
            type: "GET",
            url: (0, _indexDefault.default).API_ROOT + "/session",
            xhrFields: {
                withCredentials: true
            }
        }).done(function(response) {
            var username = $(".header").find(".name");
            username.text(username.text() + response.data.fname + " " + response.data.lname + " | ");
            $(".header").find("a.demo").attr("href", (0, _indexDefault.default).ROOT);
            $(".login-form").hide();
            $(".header").find(".user-name").fadeIn();
        }).fail(function(data) {
            $(".header").find(".user-name").hide();
            $(".login-form").fadeIn();
        });
    }; // Do initial session check
    refreshSession();
    $(".login-form").submit(function(event) {
        event.preventDefault();
        var errorSpan = $(this).find(".errors");
        errorSpan.text("");
        $.ajax({
            type: "POST",
            url: (0, _indexDefault.default).API_ROOT + "/login",
            data: $(this).serialize(),
            xhrFields: {
                withCredentials: true
            }
        }).done(function(response) {
            errorSpan.text("");
            window.location = (0, _indexDefault.default).ROOT;
        }).fail(function(response) {
            if (response.responseText) errorSpan.text(JSON.parse(response.responseText).status.message);
            else errorSpan.text("An unexpected error occured. Please try again.");
        });
    });
    $(".logout").click(function(event) {
        event.preventDefault();
        var errorSpan = $(this).children(".errors");
        $.ajax({
            type: "GET",
            url: (0, _indexDefault.default).API_ROOT + "/logout",
            xhrFields: {
                withCredentials: true
            }
        }).done(function(response) {
            errorSpan.text("");
            refreshSession();
        }).fail(function(response) {
            if (response.responseText) errorSpan.text(JSON.parse(response.responseText).status.message);
            else errorSpan.text("An unexpected error occured. Please try again.");
        }); // $http.get(API_ROOT+'/logout').success(function() {
    //     $window.location = protocol+'//'+DOMAIN;
    // });
    }); // logout = function() {
    //     $.get(config.API_ROOT+'/logout').success(function() {
    //         $window.location = config.ROOT;
    //     });
    // }
    $(".forgot-password-form").submit(function(event) {
        event.preventDefault();
        var info = $(this).find(".return-info"), errorSpan = $(this).find(".errors");
        $.ajax({
            type: "POST",
            url: (0, _indexDefault.default).API_ROOT + "/password/remind",
            data: $(this).serialize(),
            xhrFields: {
                withCredentials: true
            }
        }).done(function(response) {
            errorSpan.empty();
            var responseMessage = response.status.message;
            info.text(responseMessage || "If a matching account exists, a password reset email will be sent shortly.");
        }).fail(function(response) {
            info.text("");
            var errors = JSON.parse(response.responseText).meta.errors;
            errorSpan.empty();
            var toAppend;
            for(var field in errors)for(var error in errors[field]){
                toAppend = "<error>" + errors[field][error] + "</error>";
                errorSpan.append(toAppend);
            }
        });
    });
    var toggleShowPassword = function(ids) {
        ids = ids instanceof Array ? ids : [
            ids
        ];
        var showing = document.getElementById(ids[0]).type === "password", checkbox = document.getElementById("showPasswordField");
        for(var id in ids){
            var x = document.getElementById(ids[id]);
            if (showing) x.type = "text";
            else x.type = "password";
        }
        checkbox.checked = showing;
    };
    if ($(".scrolltop").length) $(".scrolltop").click(function() {
        $.scrollTo($($(this).attr("href")), {
            duration: 750
        });
        return false;
    });
    if ($(".fancybox").length) $(".fancybox").fancybox({
        padding: 0
    });
    $(function() {
        if (window.PIE) $(".ie-fix").each(function() {
            PIE.attach(this);
        });
    });
});

},{"../../app/configuration/index":"liepd","@parcel/transformer-js/src/esmodule-helpers.js":"dpH1E"}],"liepd":[function(require,module,exports) {
/**
 * Global application configuration
 */ var config = {};
config.protocol = "https:";
config.DOMAIN = "epiphanyanalytics.com";
config.ROOT = config.protocol + "//app." + config.DOMAIN;
config.REACT_ROOT = config.ROOT + "/react";
config.API_ROOT = config.protocol + "//tardis." + config.DOMAIN + "/api";
config.SHARING_ROOT = config.protocol + "//" + config.DOMAIN + "/maps";
config.LEGACY_DOMAIN = config.protocol + "//reports." + config.DOMAIN;
config.DEV = false;
config.TILE_URL = config.protocol + "//tiles." + config.DOMAIN;
config.TEGOLA_URL = config.protocol + "//vectors." + config.DOMAIN;
config.PUBLIC_GA_ID = "UA-44954143-3";
config.APP_GA_ID = "UA-44954143-4"; // Google geocoder API key
config.GEOCODE_KEY = "AIzaSyAEmYSgkebJuliyVrE40cUJzNVTDyDVUxc"; // Settings for Fine Uploader
config.S3_BUCKET_URL = "https://epiphany-files-production.s3.amazonaws.com";
config.S3_ACCESS_KEY = "AKIAIEKZRFDDAM7BJVQQ";
config.S3_REGION = "us-west-1"; // The mapbox tile info
config.MAPBOX_USER = "geostrategies";
config.MAPBOX_STYLE_ID = "ckhlcedni05ps19rq0a0xd7ls";
config.MAPBOX_TILE_SIZE = 256;
config.MAPBOX_HIGHDPI = false;
config.MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZ2Vvc3RyYXRlZ2llcyIsImEiOiI0NC1DRVhrIn0.OIEcZz0WqPaMgsyKRu6ycg"; // The Datadog application id
config.DATADOG_APP_ID = "0d17233e-3182-4eb8-ae8c-ef7945d129e3";
config.THEME = "";
if (0, module.exports) module.exports = config;

},{}],"dpH1E":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["ljydh"], "ljydh", "parcelRequire5cdf")

//# sourceMappingURL=index.1b4fea6c.js.map
